module.exports = __webpack_public_path__ + "static/media/accial-logo.a76e688c.png";